import { useDocumentData } from 'react-firebase-hooks/firestore';
import Firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

export default function useCustomerProfileConfig(shopId) {
    const ref = shopId ? Firebase.firestore().collection('shops').doc(shopId).collection('installData').doc('customerProfile') : null;
    const [ customerProfileConfig, customerProfileConfigLoading, customerProfileConfigError] = useDocumentData(ref);
    return { customerProfileConfig, customerProfileConfigLoading, customerProfileConfigError }
}
